export default "__VITE_ASSET__DrEr1INX__"